import { computed, reactive, toValue } from "vue";
import { useAsyncData } from "#app";
import { hash } from "ohash";
import {
  createItem as sdkCreateItem,
  createItems as sdkCreateItems,
  readItem as sdkReadItem,
  readItems as sdkReadItems,
  readSingleton as sdkReadSingleton,
  updateItem as sdkUpdateItem,
  updateItems as sdkUpdateItems,
  updateSingleton as sdkUpdateSingleton,
  deleteItem as sdkDeleteItem,
  deleteItems as sdkDeleteItems
} from "@directus/sdk";
import { useDirectusRest } from "#imports";
export function useDirectusItems(config) {
  const client = useDirectusRest(config);
  async function createItem(collection, item, query) {
    return await client.request(sdkCreateItem(collection, item, query));
  }
  async function createItems(collection, items, query) {
    return await client.request(sdkCreateItems(collection, items, query));
  }
  async function readItem(collection, id, query) {
    return await client.request(sdkReadItem(collection, id, query));
  }
  async function readAsyncItem(collection, id, params) {
    const { key, query, ..._params } = params ?? {};
    const _key = computed(() => {
      return key ?? "D_" + hash(["readAsyncItem", toValue(collection), toValue(id), toValue(query)]);
    });
    return await useAsyncData(_key.value, () => readItem(toValue(collection), toValue(id), reactive(query ?? {})), _params);
  }
  async function readItems(collection, query) {
    return await client.request(sdkReadItems(collection, query));
  }
  async function readAsyncItems(collection, params) {
    const { key, query, ..._params } = params ?? {};
    const _key = computed(() => {
      return key ?? "D_" + hash(["readAsyncItems", toValue(collection), toValue(query)]);
    });
    return await useAsyncData(_key.value, () => readItems(toValue(collection), reactive(query ?? {})), _params);
  }
  async function readSingleton(collection, query) {
    return await client.request(sdkReadSingleton(collection, query));
  }
  async function readAsyncSingleton(collection, params) {
    const { key, query, ..._params } = params ?? {};
    const _key = computed(() => {
      return key ?? "D_" + hash(["readAsyncSingleton", toValue(collection), toValue(query)]);
    });
    return await useAsyncData(_key.value, () => readSingleton(toValue(collection), reactive(query ?? {})), _params);
  }
  async function updateItem(collection, id, item, query) {
    return await client.request(sdkUpdateItem(collection, id, item, query));
  }
  async function updateItems(collection, ids, item, query) {
    return await client.request(sdkUpdateItems(collection, ids, item, query));
  }
  async function updateSingleton(collection, item, query) {
    return await client.request(sdkUpdateSingleton(collection, item, query));
  }
  async function deleteItem(collection, id) {
    return await client.request(sdkDeleteItem(collection, id));
  }
  async function deleteItems(collection, idsOrQuery) {
    return await client.request(sdkDeleteItems(collection, idsOrQuery));
  }
  return {
    client,
    createItem,
    createItems,
    readItem,
    readAsyncItem,
    readItems,
    readAsyncItems,
    readSingleton,
    readAsyncSingleton,
    updateItem,
    updateItems,
    updateSingleton,
    deleteItem,
    deleteItems
  };
}
